/* Full description remains in original HTML above products: native details toggles. */
(() => {
  function bind(scope) {
    const layouts=scope?.matches?.('.bv-collection-layout')?[scope]:[...(scope?.querySelectorAll?.('.bv-collection-layout')||[])];
    for(const layout of layouts) {
      if(layout.dataset.bvSeoBound==='true')continue;
      layout.dataset.bvSeoBound='true';
      const details=layout.querySelector('.bv-collection-top__more');
      if(!details)continue;
      const mq=window.matchMedia('(max-width:749px)');
      let activeMode;
      function sync() {
        const next=mq.matches?layout.dataset.bvTopMobile:layout.dataset.bvTopDesktop;
        if(next!==activeMode){details.open=(next==='full');activeMode=next}
      }
      sync();
      if(mq.addEventListener)mq.addEventListener('change',sync);
      else mq.addListener(sync);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>bind(document),{once:true});
  else bind(document);
  document.addEventListener('shopify:section:load',e=>bind(e.target));
})();
